import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { AlertCircle, RefreshCw } from "lucide-react";

export default function Dashboard() {
  const { user, loading, checkAuth } = useAuth();
  const navigate = useNavigate();
  const [stuck, setStuck] = useState(false);

  useEffect(() => {
    if (loading) return;
    if (!user) {
      // Wait a moment for auth check to complete after OAuth cookie is set
      const t = setTimeout(() => setStuck(true), 1500);
      return () => clearTimeout(t);
    }
    if (!user.role) navigate("/onboarding", { replace: true });
    else if (user.role === "talent") navigate("/talent", { replace: true });
    else if ((user.role === "creator" || user.role === "professional")) navigate("/createurs", { replace: true });
    else if (user.role === "admin") navigate("/admin", { replace: true });
  }, [user, loading, navigate]);

  const retry = async () => {
    setStuck(false);
    await checkAuth();
  };

  const reLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    localStorage.removeItem("helencia_token");
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (stuck && !user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] px-6" data-testid="dashboard-stuck">
        <div className="max-w-md w-full bg-white rounded-2xl border border-[#EADDC9] p-8 text-center">
          <div className="w-12 h-12 rounded-full bg-[#FAF3EA] flex items-center justify-center mx-auto mb-4">
            <AlertCircle className="w-6 h-6 text-[#8B5A2B]" />
          </div>
          <p className="font-serif text-2xl text-[#1A1A1A] mb-2">Session non détectée</p>
          <p className="text-sm text-[#666] mb-6">
            Nous n'avons pas pu récupérer votre session. Essayez de réessayer ou de vous reconnecter.
          </p>
          <div className="flex flex-col gap-2">
            <Button onClick={retry} variant="outline" className="rounded-full border-[#1A1A1A]" data-testid="dashboard-retry-btn">
              <RefreshCw className="w-4 h-4 mr-2" /> Réessayer
            </Button>
            <Button onClick={reLogin} className="rounded-full bg-[#C68E59] hover:bg-[#A26F3E] text-white" data-testid="dashboard-relogin-btn">
              Me reconnecter
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="w-10 h-10 border-2 border-[#1A1A1A] border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
}
